if (!window.__dcCalculatorLoaded) {
  window.__dcCalculatorLoaded = true;

/* ==========================================================================
   Calculator Config
   ========================================================================== */
const CALCULATORS = {
  etch: {
    coverage: 200,
    unit: 'gallons',
    smallestUnit: 0.25,
    multipliers: [{ label: '1 Coat', value: 1, default: true }],
    sizes: [
      { label: '5 Gallons', value: 5 },
      { label: '1 Gallon', value: 1 },
    ]
  },
  concreteStain: {
    coverage: 200,
    unit: 'gallons',
    smallestUnit: 0.03125,
    multipliers: [
      { label: '1 Coat', value: 0.5 },
      { label: '2 Coats (recommended)', value: 1, default: true },
      { label: '3 Coats (Very Porous)', value: 1.5 }
    ],
    sizes: [
      { label: '5 Gallons', value: 5 },
      { label: '1 Gallon', value: 1 },
    ]
  },
  paverStain: {
    coverage: 200,
    unit: 'gallons',
    smallestUnit: 0.03125,
    multipliers: [
      { label: '1 Coat', value: 0.5 },
      { label: '2 Coats (recommended)', value: 1, default: true },
      { label: '3 Coats (Very Porous)', value: 1.5 }
    ],
    sizes: [
      { label: '1 Gallon', value: 1 },
    ]
  },
  penetratingSealer: {
    coverage: 200,
    unit: 'gallons',
    smallestUnit: 0.03125,
    sizes: [
      { label: '5 Gallons', value: 5 },
      { label: '1 Gallon', value: 1 },
    ]
  },
  acrylicSealer: {
    coverage: 200,
    unit: 'gallons',
    smallestUnit: 0.03125,
    multipliers: [
      { label: '1 Coat', value: 0.5 },
      { label: '2 Coats (recommended)', value: 1, default: true },
      { label: '3 Coats', value: 1.5 }
    ],
    sizes: [
      { label: '5 Gallons', value: 5 },
      { label: '1 Gallon', value: 1 },
    ]
  },
  concreteDye: {
    coverage: 150,
    unit: 'gallons',
    smallestUnit: 0.0390625,
    multipliers: [
      { label: '2–3 thin coats', value: 1, default: true },
      { label: '5 thin coats', value: 2 }
    ],
    sizes: [
      { label: '5 Gallons', value: 5 },
      { label: '1 Gallon', value: 1 },
    ]
  },
  concreteDye1Gal: {
    coverage: 150,
    unit: 'kits',
    smallestUnit: 1,
    multipliers: [
      { label: '2–3 thin coats', value: 1, default: true },
      { label: '5 thin coats', value: 2 }
    ],
    sizes: [{ label: '1 Gallon Kit', value: 1 }]
  },
  concreteDye5Gal: {
    coverage: 750,
    unit: 'mega bundles',
    smallestUnit: 1,
    multipliers: [
      { label: '2–3 thin coats', value: 1, default: true },
      { label: '5 thin coats', value: 2 }
    ],
    sizes: [{ label: '5 Gallon Mega Bundle', value: 1 }]
  },
  colorbomb: {
    coverage: 26.7,
    unit: 'pounds',
    smallestUnit: 15,
    multipliers: [{ label: '1 Coat', value: 1, default: true }],
    sizes: [
      { label: '30 pounds', value: 30 },
    ]
  },
  concreteFloorWax: {
    coverage: 1000,
    unit: 'gallons',
    smallestUnit: 0.03125,
    multipliers: [
      { label: '1 Coat', value: 1, default: true },
      { label: '2 Coats', value: 2 },
      { label: '3 Coats', value: 3 }
    ],
    sizes: [
      { label: '5 Gallons', value: 5 },
      { label: '1 Gallon', value: 1 }
    ]
  },
  stainMegaBundle: {
    coverage: 1000,
    unit: 'mega bundles',
    smallestUnit: 1,
    multipliers: [
      // { label: '1 Coat', value: 0.5 },
      { label: '2 Coats (recommended)', value: 1, default: true },
      // { label: '3 Coats', value: 1.5 },
      { label: '4 Coats', value: 2 }
    ],
    sizes: [
      { label: '5 Gallon Mega Bundle', value: 1 }
    ]
  },
  stainKitCalc: {
    coverage: 200,
    unit: 'kits',
    smallestUnit: 1,
    multipliers: [
      // { label: '1 Coat', value: 0.5 },
      { label: '2 Coats (recommended)', value: 1, default: true },
      // { label: '3 Coats', value: 1.5 },
      { label: '4 Coats', value: 2 }
    ],
    sizes: [
      { label: '1 Gallon Kit', value: 1 }
    ]
  },
  pigment: {
    unit: 'pounds',
    smallestUnit: 1,
    sizes: [
      { label: '25 Pounds', value: 25 },
      { label: '10 Pounds', value: 10 },
      { label: '5 Pounds', value: 5 },
      { label: '1 Pound', value: 1 }
    ],
    modes: {
      num_bags_prebagged_concrete_mix: {
        calc: ({ bags, weight, rate }) => bags * weight * rate * 0.0013796
      },
      num_bags_5000psi_countertop_mix: {
        calc: ({ bags, weight, rate }) => bags * weight * rate * (0.0013796 * 2.2)
      },
      truck_pour_per_yard_concrete: {
        calc: ({ yards, psi, rate }) => yards * psi * rate
      },
      num_bags_portland_cement: {
        calc: ({ bags, weight, rate }) => ((bags * weight) / 94) * rate
      }
    }
  }
};

const DEFAULT_CALCULATOR = {
  coverage: 1,
  unit: '',
  smallestUnit: 1,
  multipliers: [{ label: 'Default', value: 1, default: true }],
  sizes: []
};

/* ==========================================================================
   Utils
   ========================================================================== */

const getNumber = v => parseFloat(v) || 0;
const getCalculatorConfig = type => ({ ...DEFAULT_CALCULATOR, ...(CALCULATORS[type] || {}) });

/* ==========================================================================
   Shopify Product Utils
   ========================================================================== */

async function getCurrentProductVariants() {
  if (window.PRODUCT_VARIANTS && Array.isArray(window.PRODUCT_VARIANTS)) {
    return window.PRODUCT_VARIANTS;
  }
  console.warn('⚠️ Product variants could not be obtained');
  return [];
}

function getSelectedProductOptions() {
  const options = {};

  document.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(input => {
    options[input.name.replace(/[-\d\s]/g, '')] = input.value;
  });

  document.querySelectorAll('.product-form__input select').forEach(select => {
    if (select.value) options[select.name || select.id || 'Option'] = select.value;
  });

  return options;
}

/* ==========================================================================
   Shopify Cart Utils
   ========================================================================== */

function findVariantId(sizeLabel, variants, selectedOptions = {}) {
  if (!variants?.length) {
    console.error('❌ No variants available');
    return null;
  }

  const normalizedSizeLabel = sizeLabel.toLowerCase().trim();
  const selectedValues = Object.values(selectedOptions).map(v => v.toLowerCase().trim());
  selectedValues[0] = normalizedSizeLabel;

  const matches = variants.filter(v => {
    if (!v) return false;

    const variantOptions = [v.title, v.option1, v.option2, v.option3]
      .filter(Boolean)
      .map(s => s.toLowerCase().trim());

    const sizeMatch = variantOptions.some(opt =>
      opt.includes(normalizedSizeLabel) || normalizedSizeLabel.includes(opt)
    );

    if (!sizeMatch) return false;

    return selectedValues.every(sel =>
      variantOptions.some(opt => opt === sel || opt.includes(sel) || sel.includes(opt))
    );
  });

  if (!matches.length) {
    console.warn(`⚠️ No variant found for "${sizeLabel}"`, selectedOptions);
    return null;
  }

  if (matches.length > 1) {
    console.warn(`⚠️ Multiple matches found (${matches.length}), using first`);
  }

  return matches[0].id;
}

function isRecipeAvailable(recipe, variants, selectedOptions) {
  return recipe.every(item => {
    const variantId = findVariantId(item.sizeLabel, variants, selectedOptions);
    if (!variantId) return false;
    const variant = variants.find(v => v.id === variantId);
    return variant?.available !== false;
  });
}

function getMainSectionId() {
  const sectionEl = document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
  if (!sectionEl) return null;
  return sectionEl.id.replace('shopify-section-', '');
}

async function findVariantIdByOptionValues(sizeLabel) {
  try {
    const sizeInput = document.querySelector(
      `.product-form__input input[type="radio"][value="${sizeLabel}"]`
    );
    if (!sizeInput) {
      console.warn(`⚠️ No size input found for: "${sizeLabel}"`);
      return null;
    }

    const allOptionValueIds = [sizeInput.dataset.optionValueId];

    document.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(input => {
      const id = input.dataset.optionValueId;
      if (id && id !== sizeInput.dataset.optionValueId && !input.value.includes('Pound')) {
        allOptionValueIds.push(id);
      }
    });

    const handle = window.PRODUCT_HANDLE || getProductHandleFromURL();

    const sectionId = getMainSectionId();
    if (!sectionId) {
      console.warn('⚠️ Section ID not found');
      return null;
    }

    const response = await fetch(
      `/products/${handle}?option_values=${allOptionValueIds.join(',')}&section_id=${sectionId}`,
      { headers: { 'Accept': 'text/html' } }
    );

    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const variantInput = doc.querySelector('input[name="id"], select[name="id"]');

    if (!variantInput) {
      console.warn('⚠️ Could not find variant input in rendered section');
      return null;
    }

    return parseInt(variantInput.value);

  } catch (error) {
    console.error('❌ Error finding variant:', error);
    return null;
  }
}

async function checkVariantAvailableByOptionValues(sizeLabel) {
  try {
    const sizeInput = document.querySelector(
      `.product-form__input input[type="radio"][value="${sizeLabel}"]`
    );
    if (!sizeInput) return false;

    const allOptionValueIds = [sizeInput.dataset.optionValueId];
    document.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(input => {
      const id = input.dataset.optionValueId;
      if (id && id !== sizeInput.dataset.optionValueId && !input.value.includes('Pound')) {
        allOptionValueIds.push(id);
      }
    });

    const handle = window.PRODUCT_HANDLE || getProductHandleFromURL();
    const sectionId = getMainSectionId();
    if (!sectionId) return false;

    const response = await fetch(
      `/products/${handle}?option_values=${allOptionValueIds.join(',')}&section_id=${sectionId}`,
      { headers: { 'Accept': 'text/html' } }
    );

    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const variantInput = doc.querySelector('input[name="id"], select[name="id"]');

    if (!variantInput) return false;
    if (variantInput.disabled) return false;
    if (variantInput.dataset.available === 'false') return false;

    return true;
  } catch {
    return false;
  }
}

async function postToCart(items) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.description || 'Failed to add to cart');
  }

  const data = await response.json();

  // Trigger cart refresh events for theme compatibility
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  window.dispatchEvent(new Event('cart:updated'));
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { items: data } }));

  return data;
}

async function updateCartUI() {
  try {
    const { item_count } = await fetch('/cart.js').then(r => r.json());

    document.querySelectorAll('.cart-count, cart-count, [data-cart-count]').forEach(counter => {
      const oldCount = parseInt(counter.textContent) || 0;
      counter.textContent = item_count;
      counter.setAttribute('aria-label', `${item_count} items`);

      if (item_count > 0) {
        counter.style.display = '';
        counter.removeAttribute('hidden');
        counter.classList.remove('hidden');
      }

      if (item_count > oldCount) {
        counter.classList.add('cart-count--updated');
        setTimeout(() => counter.classList.remove('cart-count--updated'), 600);
      }
    });

    const cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;

    if (typeof cartDrawer.onCartRefresh === 'function') {
      await cartDrawer.onCartRefresh({ detail: { open: true } });
    }

    await new Promise(resolve => setTimeout(resolve, 400));

    // Rebind close button after drawer re-render
    const closeBtn = cartDrawer.querySelector('.drawer__close-btn');
    if (closeBtn) {
      const freshBtn = closeBtn.cloneNode(true);
      closeBtn.replaceWith(freshBtn);
      freshBtn.addEventListener('click', () => {
        if (typeof cartDrawer.hide === 'function') {
          cartDrawer.hide();
        } else {
          cartDrawer.removeAttribute('open');
          cartDrawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflow-hidden');
        }
      });
    }

  } catch (error) {
    console.error('❌ Error updating cart UI:', error);
  }
}

/* ==========================================================================
   Init
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dc-calculator').forEach(initCalculator);
});

function initCalculator(calc) {
  const config = getCalculatorConfig(calc.dataset.calculator);
  const $ = sel => calc.querySelector(sel);

  const totalEl = $('[data-result="total"]');
  const unitEl = $('[data-result="unit"]');
  const recipeBody = $('[data-result="recipe"]');
  const addToCartBtn = $('[data-add-to-cart]');
  const coatsWrapper = $('[data-coats-wrapper]');

  const inputs = {
    length: $('[data-input="length"]'),
    width: $('[data-input="width"]'),
    coats: $('[data-input="coats"]')
  };

  const modeRadios = calc.querySelectorAll('[data-mode-radio]');
  const modeBlocks = calc.querySelectorAll('[data-mode]');
  let activeMode = modeRadios[0]?.value || null;

  let currentRecipe = [];
  let productVariants = [];

  setup();
  renderEmptyRecipe();
  calculate();

  calc.querySelectorAll('input, select').forEach(el => {
    el.addEventListener('input', calculate);
    el.addEventListener('change', calculate);
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleAddToCart);
    loadProductVariants();
  }

  // Pigment only: re-run calculate() when the Color swatch changes.
  if (config.modes) {
    document.addEventListener('change', function onColorSwatchChange(e) {
      const radio = e.target;
      if (!radio.matches('.swatch-input__input')) return;
      const fieldset = radio.closest('.product-form__input');
      if (!fieldset) return;
      const legend = fieldset.querySelector('legend');
      if (!legend || !/color/i.test(legend.textContent)) return;

      calculateWithRadio(radio);
    });
  }

  /* ============================
     Setup
     ============================ */

  function setup() {
    if (unitEl) unitEl.textContent = config.unit;
    config.modes ? setupPigmentModes() : setupCoats();
  }

  function setupCoats() {
    if (!inputs.coats) return;

    const options = config.multipliers || [];
    if (options.length <= 1) {
      coatsWrapper?.style.setProperty('display', 'none');
      inputs.coats.value = options[0]?.value || 1;
      return;
    }

    inputs.coats.innerHTML = options.map(o => `<option value="${o.value}">${o.label}</option>`).join('');
    inputs.coats.value = (options.find(o => o.default) || options[0]).value;
  }

  function setupPigmentModes() {
    showModeBlock(activeMode);
    modeRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        activeMode = radio.value;
        showModeBlock(activeMode);
        calculate();
      });
    });
  }

  function showModeBlock(mode) {
    modeBlocks.forEach(block => {
      const isActive = block.dataset.mode === mode;
      block.style.display = isActive ? '' : 'none';
      if (!isActive) {
        block.querySelectorAll('input[type="number"]').forEach(inp => inp.value = '');
      }
    });
  }

  /* ============================
     Variants
     ============================ */

  async function loadProductVariants() {
    try {
      productVariants = await getCurrentProductVariants();
      if (!productVariants.length) {
        console.warn('⚠️ No variants loaded.');
      } else {

        checkRecipeAvailability();
      }
    } catch (error) {
      console.error('Error loading variants:', error);
    }
  }

  /* ============================
     Calculations
     ============================ */

  function getArea() {
    return getNumber(inputs.length?.value) * getNumber(inputs.width?.value);
  }

  function getNeededAmount(area) {
    return (area / config.coverage) * (getNumber(inputs.coats?.value) || 1);
  }

  function getPigmentInputs() {
    const container = calc.querySelector(`[data-mode="${activeMode}"]`);
    if (!container) return {};
    return [...container.querySelectorAll('[data-input]')].reduce((acc, el) => {
      acc[el.dataset.input] = getNumber(el.value);
      return acc;
    }, {});
  }

  function roundToBuyable(amount) {
    return Math.ceil(amount / config.smallestUnit) * config.smallestUnit;
  }

  function getColorSwatchRadio() {
    // Used on page load / manual input changes — reads :checked from Color fieldset
    for (const fieldset of document.querySelectorAll('.product-form__input')) {
      const legend = fieldset.querySelector('legend');
      if (legend && /color/i.test(legend.textContent)) {
        return fieldset.querySelector('.swatch-input__input:checked') || null;
      }
    }
    for (const radio of document.querySelectorAll('.swatch-input__input:checked')) {
      if (/^\d{3}-\d+$/.test(radio.value.trim())) return radio;
    }
    return null;
  }

  function getRateFromRadio(radio) {
    if (!radio) return 1;
    const parts = radio.value.trim().split('-');
    const rate  = parseFloat(parts[parts.length - 1]);
    return (!rate || rate === 0) ? 0.5 : rate;
  }

  function getNameFromRadio(radio) {
    if (!radio) return '';
    const nameEl = document.querySelector('[data-selected-swatch-value="Color"]');

    const label = document.querySelector(`label[for="${radio.id}"]`);
    const code  = label ? (label.getAttribute('title') || radio.value) : radio.value;
    const displayName = nameEl ? nameEl.textContent.trim() : '';
    
    // Only use displayName if it already matches the clicked radio's value
    return (displayName && displayName === code) ? displayName : code;
  }

  function updatePigmentTitle(radio) {
    const titleEl = calc.querySelector('.dc-calculator__pigment-color-name');
    if (!titleEl) return;
    titleEl.textContent = getNameFromRadio(radio || getColorSwatchRadio());
  }

  function getPigmentRate(radio) {
    return getRateFromRadio(radio || getColorSwatchRadio());
  }

  // Called on swatch click — radio is passed directly from e.target (no :checked timing issue)
  function calculateWithRadio(radio) {
    if (!config.modes) return;
    const mode = config.modes[activeMode];
    if (!mode) return;
    const needed = mode.calc({ ...getPigmentInputs(), rate: getRateFromRadio(radio) });

    const buyable = roundToBuyable(needed);

    if (totalEl) totalEl.textContent = needed > 0 ? Math.ceil(needed) : '0';
    if (unitEl) unitEl.textContent = config.unit;
    updatePigmentTitle(radio);
    renderRecipe(buyable);
  }

  function calculate() {
    let needed = 0;

    if (config.modes) {
      const mode = config.modes[activeMode];
      if (!mode) return;
      needed = mode.calc({ ...getPigmentInputs(), rate: getPigmentRate() });
      updatePigmentTitle();
    } else {
      needed = getNeededAmount(getArea());
    }

    const buyable = roundToBuyable(needed);

    if (totalEl) totalEl.textContent = needed > 0 ? Math.ceil(needed) : '0';
    if (unitEl) unitEl.textContent = config.unit;

    renderRecipe(buyable);
  }

  /* ============================
     Rendering
     ============================ */

  function renderEmptyRecipe() {
    if (!recipeBody) return;
    recipeBody.innerHTML = `<tr><td>0 ${config.unit}</td><td>0</td></tr>`;
    currentRecipe = [];
    updateAddToCartButton();
  }

  function renderRecipe(total) {
    if (!recipeBody) return;

    if (!total || total <= 0) {
      renderEmptyRecipe();
      return;
    }

    recipeBody.innerHTML = '';
    currentRecipe = [];
    let remaining = total;

    [...config.sizes]
      .sort((a, b) => b.value - a.value)
      .forEach((size, i, arr) => {
        const isLast = i === arr.length - 1;
        const qty = isLast ? Math.ceil(remaining / size.value) : Math.floor(remaining / size.value);
        if (qty <= 0) return;

        remaining -= qty * size.value;
        currentRecipe.push({ sizeLabel: size.label, sizeValue: size.value, quantity: qty });
        recipeBody.insertAdjacentHTML('beforeend', `<tr><td>${size.label}</td><td>${qty}</td></tr>`);
      });

    updateAddToCartButton();
    checkRecipeAvailability();
  }

  function updateAddToCartButton() {
    if (!addToCartBtn) return;
    const hasRecipe = currentRecipe.length > 0;
    addToCartBtn.style.display = hasRecipe ? 'inline-flex' : 'none';
    addToCartBtn.disabled = !hasRecipe;
  }

  /* ============================
     Availability
     ============================ */

  async function checkRecipeAvailability() {
    if (!addToCartBtn || !currentRecipe.length) return;

    if (config.modes) {
      // Pigment: verify availability via fetch for each size in the recipe
      for (const item of currentRecipe) {
        const available = await checkVariantAvailableByOptionValues(item.sizeLabel);
        if (!available) {
          setOutOfStock();
          return;
        }
      }
    } else {
      // Normal variants: use the already-loaded variants array
      if (!productVariants.length) return; // still loading, don't block yet
      const selectedOptions = getSelectedProductOptions();
      const available = isRecipeAvailable(currentRecipe, productVariants, selectedOptions);
      if (!available) {
        setOutOfStock();
        return;
      }
    }

    // All items available
    setInStock();
  }

  function setOutOfStock() {
    if (!addToCartBtn) return;
    addToCartBtn.disabled = true;
    addToCartBtn.style.opacity = '0.5';
    addToCartBtn.style.cursor = 'not-allowed';
    setBtnState('Out of Stock');
  }

  function setInStock() {
    if (!addToCartBtn) return;
    addToCartBtn.disabled = false;
    addToCartBtn.style.opacity = '';
    addToCartBtn.style.cursor = '';
    setBtnState('Add Recipe to Cart');
  }

  /* ============================
     Add to Cart
     ============================ */

  function setBtnState(text, color = '') {
    const btnText = addToCartBtn.querySelector('.btn__text');
    if (!btnText) return;
    btnText.textContent = text;
    btnText.style.color = color;
  }

  function resetBtn(delay) {
    setTimeout(() => {
      setBtnState('Add Recipe to Cart');
      addToCartBtn.disabled = false;
    }, delay);
  }

  async function handleAddToCart() {
    if (!addToCartBtn || !currentRecipe.length) return;

    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('btn--loading');

    try {
      const cartItems = [];

      if (config.modes) {
        for (const item of currentRecipe) {
          const variantId = await findVariantIdByOptionValues(item.sizeLabel);
          if (variantId) cartItems.push({ id: variantId, quantity: item.quantity });
        }
      } else {
        if (!productVariants.length) await loadProductVariants();
        if (!productVariants.length) throw new Error('Could not load product variants. Please refresh.');

        const selectedOptions = getSelectedProductOptions();
        for (const item of currentRecipe) {
          const variantId = findVariantId(item.sizeLabel, productVariants, selectedOptions);
          if (variantId) cartItems.push({ id: variantId, quantity: item.quantity });
        }
      }

      if (!cartItems.length) throw new Error('No valid variants found.');

      await postToCart(cartItems);
      await updateCartUI();

      setBtnState('Added to Cart!');
      resetBtn(2000);

    } catch (error) {
      console.error('❌ Error:', error);
      setBtnState('Error - Try Again', 'var(--color-error, #ff1100)');
      resetBtn(3000);

    } finally {
      addToCartBtn.classList.remove('btn--loading');
    }
  }
}

} // end window.__dcCalculatorLoaded guard